import { render } from "./browser-guide.vue?vue&type=template&id=07d447f8&scoped=true"
import script from "./browser-guide.vue?vue&type=script&lang=ts"
export * from "./browser-guide.vue?vue&type=script&lang=ts"

import "./browser-guide.vue?vue&type=style&index=0&id=07d447f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-07d447f8"

export default script